import { api } from '@services';

import Product, { IProduct, IProductApiModel } from '@models/Product.model';

const indexDocumentProducts = async (id?: string): Promise<IProduct[]> => {
  const { data: products } = await api.get<IProductApiModel[]>(
    `/documents/${id}/products`,
  );

  return Product.arrayFromApiModel(products);
};

export { indexDocumentProducts };
